<template>
	<card class="ReChannelEdit">
		<h3 class="mb-1" v-if="bIsNew">Создать событие [задачу]</h3>
		<!--Новый канал заменить на{{strChannelName}} или что там будет в будущем объекте-->
		<h3 v-else>Редактирование события</h3>
		<hr />

        <h4>Конфиг собран не до конца. Нет блока про Место проведения (офис, помещение, бронь)</h4>


		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 			
			:SuccessGo="SuccessGo" 
			:CancelGo="CancelGo"/>
	</card>
</template>

<script>
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
	name: "ReTasksEdit",
	components: {
		ReFormPrinter
	},
	props: {
		counter: String,
		findId: {
			type: String,
			default: ""
		},
		
	},
	data() {
		return {
			masAllFormParams: this.currentFormConfig(),			
		};
	},
	computed: {
		bIsNew: function() {
			if (location.pathname.indexOf("/data/tasks/add") !== -1) {
				return true;
			}
			return false;
		}
		/*strChannelName: function() {
			if (typeof this.objChannel.id != "undefined") {
				return this.objChannel.title;
			}
			return "Новый канал";
		}*/
	},

	methods: {
		currentFormConfig() {
			return require("src/conf/tasksFormConfig.js").super_config; 
			return [];
		},
		SuccessGo(evt) {
			if (location.pathname.indexOf("/data/tasks/add") != -1) {
				this.$router.push({ path: "/data/tasks" });
			} else {
				this.$router.push({ path: this.$GVO.str_replace("/edit", "", evt) });
			}
		},
		CancelGo(){
			this.$router.go(-1);
		}
	}
};
</script>
<style scoped>
.ReChannelEdit hr {
	color: #01b0e0;
	background-color: #01b0e0;
	height: 2px;
}
</style>